import React from 'react';
import { FormattedMessage } from 'react-intl';
import classes from './styles.module.css';

function MobileCard({ row, currentId, onClick }) {
    const safeRow = row || {};
    const isActive = currentId === safeRow.id;
    const isEnabled = safeRow.status === 1;

    const status = {
        id: isEnabled ? 'TerminalsList.status.active' : 'TerminalsList.status.inactive',
        defaultMessage: isEnabled ? 'Active' : 'Inactive',
        color: isEnabled ? '#1b8356' : '#a43232',
    };

    return (
        <div
            className={classes.MobileCard}
            onClick={() => onClick(safeRow)}
            role='button'
            style={isActive ? { borderBottomColor: status.color } : null}
        >
            <div className={classes.MobilePrimary}>
                <span className={classes.MobileName}>{safeRow.name || '-'}</span>
                <span className={classes.MobileStatus} style={{ color: status.color }}>
                    <FormattedMessage id={status.id} defaultMessage={status.defaultMessage} />
                </span>
            </div>

            <div className={classes.MobileMetaRow}>
                <span className={classes.MobileMeta}>#{safeRow.id || '-'}</span>
                <span className={classes.MobileMeta}>{safeRow.projectName || '—'}</span>
            </div>

            <div className={classes.MobileSecondaryRow}>
                <span className={classes.MobileValue}>{safeRow.providerName || '—'}</span>
                <span className={classes.MobileValue}>
                    <FormattedMessage id='TerminalsList.table.balance' defaultMessage='Баланс' />:{' '}
                    {typeof safeRow.balance === 'number' ? safeRow.balance : 0}
                </span>
            </div>
        </div>
    );
}

export default MobileCard;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalsList/MobileCard.js